import createReducer from '../createReducer';
import { GET_CURRENT_USER, GET_CURRENT_USER_SUCCESS, GET_CURRENT_USER_FAIL, LOGOUT } from '../actions/auth';

export const initialState = {
  user: null,
  pending: false,
  finished: false,
};

export default createReducer(initialState, {
  [GET_CURRENT_USER]: draft => {
    draft.pending = true;
  },

  [GET_CURRENT_USER_SUCCESS]: (draft, action) => {
    draft.pending = false;
    draft.finished = true;
    draft.user = action.user;
  },

  [GET_CURRENT_USER_FAIL]: draft => {
    draft.pending = false;

    draft.finished = true;
  },

  [LOGOUT]: () => {
    return initialState;
  },
});
